module.exports = __webpack_public_path__ + "img/bg_ligon.71e66931.png";